import { render, staticRenderFns } from "./SignFeedback.vue?vue&type=template&id=4ba80f29&scoped=true"
import script from "./SignFeedback.vue?vue&type=script&lang=ts"
export * from "./SignFeedback.vue?vue&type=script&lang=ts"
import style0 from "./SignFeedback.vue?vue&type=style&index=0&id=4ba80f29&prod&lang=scss"
import style1 from "./SignFeedback.vue?vue&type=style&index=1&id=4ba80f29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba80f29",
  null
  
)

export default component.exports